import { useQuery } from "@tanstack/react-query"
import {
  getErrorLogs,
  getErrorLogWithMessageId,
  getErrorRelatedReports,
} from "../api/errorLogs"

export const useErrorLogsData = ({ page, limit, filters }) =>
  useQuery({
    queryKey: ["error-logs", page, limit, filters],
    queryFn: () => getErrorLogs({ page, limit, filters }),
    retry: false,
  })

export const useErrorLog = (messageId, bodyPart, viewType, ov3Id, source) =>
  useQuery({
    queryKey: ["error-log", messageId, bodyPart, viewType, ov3Id, source],
    queryFn: () =>
      getErrorLogWithMessageId(messageId, bodyPart, viewType, ov3Id, source),
    retry: false,
    enabled: (!!messageId || !!ov3Id) && !!bodyPart,
  })

export const useErrorRelatedReports = ({ page, limit, filters }) =>
  useQuery({
    queryKey: ["error-related-reports", page, limit, filters],
    queryFn: () => getErrorRelatedReports({ page, limit, filters }),
    retry: false,
  })
